// extracted by mini-css-extract-plugin
export default {"modalOverlay":"SavePopup_modalOverlay__LOLuY","modalContent":"SavePopup_modalContent__PwsgL","buttonRow":"SavePopup_buttonRow__3U5Z1","cancelBtn":"SavePopup_cancelBtn__A1KdS"};